module.exports = __webpack_public_path__ + "img/150-6.d03bd8ca.jpg";